import { GetAllCompanyDto, GetOneExpeditionResponseDto } from "@/types/api/api-types";
import { OtherCustomQuotationTypeEnum } from "@/constants/enums/otherCustomQuotationType.enum";
import { ParcelProductTypeEnum } from "@/constants/enums/parcelProductType.enum";
import { CustomCotationFormData } from "@/types/forms/home/customCotationsForm.form";

export const customQuotationFormDefault = (
  activeTab: number,
  company: GetAllCompanyDto,
  expedition?: GetOneExpeditionResponseDto,
): CustomCotationFormData => {
  const prefPickUpLocation =
    localStorage.getItem("prefPickUpLocation") ||
    company?.pickUpLocations?.find((el) => el.isDefault)?.id ||
    undefined;
  const defaultBillingEntity =
    company?.billingEntities.length === 1 ? company?.billingEntities[0].id : undefined;

  if (expedition) {
    return {
      ...(!expedition.pickupInfo
        ? {
            pickupInfo: {
              manualPickup: false,
              pickupLocationId: undefined as unknown as string,
            },
          }
        : expedition.pickupInfo.pickupLocation
          ? {
              pickupInfo: {
                manualPickup: false,
                pickupLocationId: expedition.pickupInfo.pickupLocation.id as unknown as string,
              },
            }
          : {
              pickupInfo: {
                manualPickup: true,
                pickupFirstName: expedition.pickupInfo.pickupFirstName as unknown as string,
                pickupLastName: expedition.pickupInfo.pickupLastName as unknown as string,
                pickupPhone: expedition.pickupInfo.pickupPhone as unknown as string,
                pickupCompany: expedition.pickupInfo.pickupCompany || undefined,
                pickupStreet: expedition.pickupInfo.pickupStreet as unknown as string,
                pickupPostalCode: expedition.pickupInfo.pickupPostalCode as unknown as string,
                pickupCity: expedition.pickupInfo.pickupCity as unknown as string,
                pickupCountry: expedition.pickupInfo.pickupCountry as unknown as string,
              },
            }),
      comment: expedition.deliveryInfo?.comment,
      reference: expedition.expeditionBillingDetail?.reference || undefined,
      deliveryInfo: {
        lastName: expedition.deliveryInfo?.lastName as unknown as string,
        firstName: expedition.deliveryInfo?.firstName as unknown as string,
        company: expedition.deliveryInfo?.company || undefined,
        phone: expedition.deliveryInfo?.phone as unknown as string,
        email: expedition.deliveryInfo?.email as unknown as string,
        street: expedition.deliveryInfo?.street as unknown as string,
        additionalInfo: expedition.deliveryInfo?.additionalInfo || undefined,
        additionalInfo2: expedition.deliveryInfo?.additionalInfo2 || undefined,
        postalCode: expedition.deliveryInfo?.postalCode as unknown as string,
        city: expedition.deliveryInfo?.city as unknown as string,
        stateOrProvinceCode: expedition.deliveryInfo?.state || undefined,
        countryCode: "",
      },
      express: expedition.expeditionOptions.express,
      insurance: expedition.expeditionOptions.insurance,
      billingEntityId: expedition.expeditionBillingDetail?.billingEntityId as unknown as string,
      newFilesId: [],
      removedFilesId: [],
      customId: expedition.customQuotation?.customId as unknown as string,
      parcelPackages:
        activeTab === 2
          ? expedition.customQuotation?.parcelDetail?.parcelPackages.map((el) => ({
              length: el.length,
              width: el.width,
              height: el.height,
              weight: el.weight,
              value: el.value,
            }))
          : [],
      parcelProducts:
        activeTab === 2
          ? expedition.customQuotation?.parcelDetail?.parcelProducts.map((el) => ({
              type: el.type as ParcelProductTypeEnum,
              volume: el.volume,
              bottleQuantity: el.bottleQuantity,
              description: el.description,
            }))
          : [],
      palettePackages:
        activeTab === 1
          ? expedition.customQuotation?.paletteDetail?.palettePackages.map((el) => ({
              length: el.length,
              width: el.width,
              height: el.height,
              weight: el.weight,
              value: el.value,
            }))
          : [],
      paletteProducts:
        activeTab === 1
          ? expedition.customQuotation?.paletteDetail?.paletteProducts.map((el) => ({
              volume: el.volume,
              bottleQuantity: el.bottleQuantity,
            }))
          : [],
    };
  }

  return {
    pickupInfo: {
      manualPickup: false,
      pickupLocationId: prefPickUpLocation as unknown as string,
    },
    comment: "",
    reference: undefined,
    deliveryInfo: {
      lastName: "",
      firstName: "",
      company: "",
      phone: "",
      email: "",
      street: "",
      additionalInfo: "",
      additionalInfo2: "",
      postalCode: "",
      city: "",
      stateOrProvinceCode: "",
      countryCode: "",
    },
    express: false,
    insurance: false,
    customId: undefined as unknown as string,
    newFilesId: [],
    billingEntityId: defaultBillingEntity as unknown as string,
    parcelPackages:
      activeTab === 2
        ? [
            {
              length: undefined as unknown as number,
              width: undefined as unknown as number,
              height: undefined as unknown as number,
              weight: undefined as unknown as number,
              value: undefined as unknown as number,
            },
          ]
        : [],
    parcelProducts:
      activeTab === 2
        ? [
            {
              type: ParcelProductTypeEnum.BOTTLE,
              volume: undefined as unknown as number,
              bottleQuantity: undefined as unknown as number,
              description: "",
            },
          ]
        : [],
    palettePackages:
      activeTab === 1
        ? [
            {
              length: undefined as unknown as number,
              width: undefined as unknown as number,
              height: undefined as unknown as number,
              weight: undefined as unknown as number,
              value: undefined as unknown as number,
            },
          ]
        : [],
    paletteProducts:
      activeTab === 1
        ? [
            {
              volume: undefined as unknown as number,
              bottleQuantity: undefined as unknown as number,
            },
          ]
        : [],
  };
};

export const customQuotationFormDefaultOther = (
  company: GetAllCompanyDto,
  expedition?: GetOneExpeditionResponseDto,
) => {
  const prefPickUpLocation =
    localStorage.getItem("prefPickUpLocation") ||
    company?.pickUpLocations?.find((el) => el.isDefault)?.id ||
    undefined;
  const defaultBillingEntity =
    company?.billingEntities.length === 1 ? company?.billingEntities[0].id : undefined;

  if (expedition) {
    return {
      ...(!expedition.pickupInfo
        ? {
            pickupInfo: {
              manualPickup: false,
              pickupLocationId: undefined,
            },
          }
        : expedition.pickupInfo.pickupLocation
          ? {
              pickupInfo: {
                manualPickup: false,
                pickupLocationId: expedition.pickupInfo.pickupLocation.id,
              },
            }
          : {
              pickupInfo: {
                manualPickup: true,
                pickupLocationId: undefined,
                pickupFirstName: expedition.pickupInfo.pickupFirstName,
                pickupLastName: expedition.pickupInfo.pickupLastName,
                pickupPhone: expedition.pickupInfo.pickupPhone,
                pickupCompany: expedition.pickupInfo.pickupCompany,
                pickupStreet: expedition.pickupInfo.pickupStreet,
                pickupPostalCode: expedition.pickupInfo.pickupPostalCode,
                pickupCity: expedition.pickupInfo.pickupCity,
                pickupCountry: expedition.pickupInfo.pickupCountry,
              },
            }),
      deliveryInfo: {
        singleDelivery: !expedition.customQuotation!.otherDetail!.isMultipleExpedition,
        deliveryLastName: expedition.deliveryInfo?.lastName,
        deliveryFirstName: expedition.deliveryInfo?.firstName,
        deliveryPhone: expedition.deliveryInfo?.phone,
        deliveryEmail: expedition.deliveryInfo?.email,
        deliveryCompany: expedition.deliveryInfo?.company,
        deliveryStreet: expedition.deliveryInfo?.street,
        deliveryPostalCode: expedition.deliveryInfo?.postalCode,
        deliveryCity: expedition.deliveryInfo?.city,
        deliveryCountry: expedition.deliveryInfo?.country,
        deliveryAdditionalInfo: expedition.deliveryInfo?.additionalInfo,
        deliveryAdditionalInfo2: expedition.deliveryInfo?.additionalInfo2,
        otherNumberOfExpedition: expedition.customQuotation!.otherDetail!.numberOfExpedition,
      },
      comment: expedition.deliveryInfo?.comment,
      express: expedition.expeditionOptions.express,
      insurance: expedition.expeditionOptions.insurance,
      reference: expedition.expeditionBillingDetail?.reference || undefined,
      newFilesId: [],
      removedFilesId: [],
      customId: expedition.customQuotation?.customId,
      billingEntityId: expedition.expeditionBillingDetail?.billingEntityId,
      otherCustomQuotationType: expedition.customQuotation!.otherDetail!
        .otherCustomQuotationType as OtherCustomQuotationTypeEnum,
    };
  }

  return {
    pickupInfo: {
      manualPickup: false,
      pickupLocationId: prefPickUpLocation,
    },
    billingEntityId: defaultBillingEntity,
    deliveryInfo: {
      singleDelivery: true,
      deliveryLastName: "",
      deliveryFirstName: "",
      deliveryPhone: "",
      deliveryEmail: "",
      deliveryCompany: "",
      deliveryStreet: "",
      deliveryPostalCode: "",
      deliveryCity: "",
      deliveryCountry: "",
      deliveryAdditionalInfo: "",
      deliveryAdditionalInfo2: "",
    },
    comment: "",
    express: false,
    insurance: false,
    reference: "",
    newFilesId: [],
    customId: undefined,
    otherCustomQuotationType: OtherCustomQuotationTypeEnum.DEFAULT,
  };
};
